const css = `.AVJs1a__selectorInput{flex-grow:1}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};

export default {"selectorInput":"AVJs1a__selectorInput"};
